import { normalizeDiacritics } from "utils";

type SearchableField = { id: string; name: string };

// Shorter id fragments would match random fields on everyday name searches
const MIN_ID_PREFIX_LENGTH = 8;

/** Comma, semicolon or newline separated terms; a field matches when any term is part of its name (diacritics-insensitive) or starts its id. */
export function createFieldSearchMatcher(searchQuery: string): (field: SearchableField) => boolean {
  const termVariants = (searchQuery || "")
    .split(/[,;\n]/)
    .map((term) => term.trim())
    .filter(Boolean)
    .map((term) => normalizeDiacritics(term));

  if (!termVariants.length) {
    return () => true;
  }

  return (field) => {
    const fieldId = field.id.toLowerCase();
    const nameVariants = normalizeDiacritics(field.name);
    return termVariants.some((variants) =>
      variants.some(
        (variant) =>
          (variant.length >= MIN_ID_PREFIX_LENGTH && fieldId.startsWith(variant)) || nameVariants.some((nameVariant) => nameVariant.includes(variant))
      )
    );
  };
}
